import * as React from "react";

export const Undo = () => (
    <>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.9433 4.8946C14.995 5.69165 15.7152 6.97918 15.7152 8.86889C15.7152 10.7586 14.995 12.0461 13.9433 12.8432C12.9189 13.6196 11.6446 13.8828 10.584 13.8828L5.28732 13.8828C4.95595 13.8828 4.68732 13.6142 4.68732 13.2828C4.68732 12.9514 4.95595 12.6828 5.28732 12.6828L10.584 12.6828C11.4736 12.6828 12.4649 12.458 13.2185 11.8868C13.9448 11.3364 14.5152 10.4169 14.5152 8.86889C14.5152 7.32086 13.9448 6.40143 13.2185 5.85097C12.4649 5.27983 11.4736 5.05497 10.584 5.05497L1.28732 5.05497C0.955948 5.05497 0.687319 4.78634 0.687319 4.45497C0.687319 4.1236 0.955948 3.85497 1.28732 3.85497L10.584 3.85497C11.6446 3.85497 12.9189 4.11821 13.9433 4.8946Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.32564 0.959039C4.52091 1.1543 4.5209 1.47088 4.32564 1.66615L1.56002 4.43175L4.30569 6.89105C4.51138 7.07529 4.52877 7.3914 4.34453 7.59709C4.16029 7.80279 3.84419 7.82018 3.63849 7.63594L0.105835 4.47172L3.61854 0.959037C3.8138 0.763776 4.13038 0.763776 4.32564 0.959039Z"
        />
    </>
);
